import * as http from "@/utils/request";

export function updateLoad(file) {
  return http.postFormData("/common/uploadFile",{file:file})
}
